import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const AppHero = ({
  titleWhite,
  titleCanton,
  styleTitleCanton,
  paragraph,
  linkBtn,
  textBtn,
  imgSrc,
  styleImg,
}) => {
  return (
    <div className="gap-9 grid xl:grid-cols-2 xl:gap-16 xl:container">
      <div className="container lg:px-0">
        <h1 className=" text-center text-creamy-beige font-light lg:mt-28 xl:text-left">
          {titleWhite}
          <span
            className={`font-semibold text-canton-jadesheen ${styleTitleCanton}`}
          >
            {" " + titleCanton}
          </span>
        </h1>
        <p className="text-creamy-beige mt-8 text-center xl:text-left">
          {paragraph}
        </p>
        {linkBtn && (
          <Link
            to={linkBtn}
            className={`app-button mt-8 bg-red mx-auto xl:mx-0 text-creamy-beige w-fit`}
          >
            {textBtn}
          </Link>
        )}
      </div>
      <img
        src={imgSrc}
        alt={titleWhite + titleCanton}
        className={`lg:mt-28 xl:max-w-[534px] xl:ml-auto ${styleImg}`}
      />
    </div>
  );
};

export default AppHero;
